import { HelperArticle } from "@tudigo-monorepo/core-tudigo-api-models";

import { ArticlePreview } from "./helper-article-preview";

export interface ArticleSectionProps {
  title: string;
  articles: HelperArticle[];
  url: string;
  knowMore?: boolean;
  className?: string;
  onArticleClick: (article: HelperArticle) => void;
}

export function ArticleSection({
  title,
  articles,
  url,
  knowMore = false,
  className,
  onArticleClick,
}: ArticleSectionProps) {
  if (articles.length === 0) return null;

  return (
    <section>
      <h2 className="body500-bold mb-4">{title}</h2>
      <div className="space-y-4">
        {articles.map((article) => (
          <ArticlePreview
            key={article.id}
            article={article}
            url={url}
            knowMore={knowMore}
            className={className}
            onClick={() => onArticleClick(article)}
          />
        ))}
      </div>
    </section>
  );
}
